module.exports = __webpack_public_path__ + "img/21.88aceca5.png";